module.exports = {
  siteTitle: 'Prateek Dubey\'s Resume', // <title>
  manifestName: 'Resume',
  manifestShortName: 'Resume', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#0b1220',
  manifestThemeColor: '#0b1220',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  firstName: 'Prateek',
  lastName: 'Dubey',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/dprateek1991',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://linkedin.com/in/prateekdubey11/',
    },
    {
      icon: 'fa-medium',
      name: 'Medium',
      url: 'https://medium.com/@prateek.dubey',
    }
  ],
  email: 'prateekdubey12@gmail.com',
  phone: '+65-93804965',
  address: '58 Bayshore Road, Singapore - 469981',
};
